<template>
  <v-app-bar id="top-app-bar" color="white" app clipped-left clipped-right elevate-on-scroll short>
    <v-app-bar-nav-icon @click.stop="toggleNavigationDrawer" />
    <router-link :to="'/'">
      <img
        v-if="$vuetify.breakpoint.mdAndUp"
        src="../assets/LTOU_logo.png"
        alt="logo"
        class="clickable ml-5"
        style="vertical-align: middle"
        height="30"
      />
    </router-link>

    <v-spacer />

    <a
      href="https://ltou.lt/lt/privatumo-politika"
      target="_blank"
      class="v-btn v-btn--flat v-btn--text theme--light"
      :class="$vuetify.breakpoint.xs ? 'v-size--small' : 'v-size--default'"
      style="color: rgba(0, 0, 0, 0.5)"
      >{{ $t('privacy_policy') }}</a
    >

    <LanguageSelector />

    <v-menu :min-width="$isExplorer() ? '215' : '42'" bottom left offset-y>
      <template v-slot:activator="{ on }">
        <v-btn large icon color="primary" v-on="on">
          <v-icon large>mdi-account-circle</v-icon>
        </v-btn>
      </template>

      <v-list subheader dense>
        <v-subheader class="text-subtitle-2">
          {{ currentUser.email }}
        </v-subheader>
        <v-divider />
        <v-list-item @click="viewProfile">
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('my_profile') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="impersonatingAs" @click="stopImpersonating">
          <v-list-item-icon>
            <v-icon>mdi-stop</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('stop_impersonating') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="onLogout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t('logout') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-btn v-if="$vuetify.breakpoint.smAndUp" color="error" class="ml-4" small @click="onLogout">
      <v-icon small>mdi-logout</v-icon>
      {{ $t('logout') }}
    </v-btn>
  </v-app-bar>
</template>

<script>
/* eslint-disable global-require*/
import { mapState } from 'vuex';
import LanguageSelector from './LanguageSelector';
import authService from '@/api/auth-service';

export default {
  name: 'Toolbar',

  components: {
    LanguageSelector,
  },

  computed: mapState('auth', ['currentUser', 'impersonatingAs']),

  methods: {
    viewProfile() {
      this.$router.push({ name: 'profile' }).catch(() => {});
    },

    toggleNavigationDrawer() {
      this.$store.commit('settings/UPDATE_SETTING', {
        key: 'sidenavOpen',
        value: !this.$store.state.settings.sidenavOpen,
      });
    },

    stopImpersonating() {
      this.$store.dispatch('auth/stopImpersonating');
    },

    onLogout() {
      return authService.logout().finally(() => {
        this.$store.dispatch('auth/logout');
      });
    },
  },
};
</script>

<style>
.theme--dark #top-app-bar.theme--light,
.theme--light #top-app-bar.theme--light {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
